import { Select, SelectProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormSelectProps<Values = Record<string, unknown>>
  extends SelectProps,
    IFocusableFormField<Values> {
  numericValue?: boolean;
}

export const FormSelect: <Values = Record<string, unknown>>(
  props: IFormSelectProps<Values>,
) => JSX.Element = ({
  fieldName,
  parentForm,
  numericValue,
  onChange,
  ...rest
}) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  const inputProps = parentForm.getInputProps(fieldName);
  if (numericValue === true) {
    inputProps.value =
      inputProps.value || inputProps.value === 0
        ? inputProps.value.toString()
        : inputProps.value;
    const inputOnChange = inputProps.onChange;
    inputProps.onChange = (value: any) => {
      const newValue =
        value && !isNaN(parseInt(value)) ? parseInt(value) : value;
      inputOnChange(newValue);
      if (onChange) {
        onChange(newValue);
      }
    };
  } else {
    if (onChange) {
      onChange(inputProps.value);
    }
  }
  return <Select {...inputProps} {...rest} ref={elementRef} />;
};
